import classNames from 'classnames';
import React from 'react';
import styles from "./block.module.css";
/**
 * The Block component. Used to signify a gray piece of content.
 *
 * @privateRemarks
 * This ideally is a private component used only in design-system-web, but we expose it to keep
 * the django-website code pointing to this.
 */

export const Block = _ref => {
  let {
    className,
    ...htmlProps
  } = _ref;
  return /*#__PURE__*/React.createElement("span", Object.assign({}, htmlProps, {
    className: classNames(styles.block, className)
  }));
};
//# sourceMappingURL=block.react-component.js.map